import loadStripeWithRetry from '@utils/loadStripeWithRetry';

// Der Publishable Key kommt zur LAUFZEIT vom Server, nicht aus dem Bundle.
//
// Grund: /public/assets liegt gebaut im Repo und bedient Produktion UND
// Render-Previews mit derselben Datei. Ein einkompilierter Key (vorher:
// Ternary auf process.env.NODE_ENV, von Vite zu einer Konstante gefaltet)
// wäre auf der Preview zwangsläufig der Live-Key — und passte damit nicht zum
// Test-`client_secret`, das der Server dort erzeugt. Stripe.js lehnt diese
// Kombination ab.
//
// Der Server löst den Key über dieselbe Weiche auf wie den Secret Key
// (lib/stripe/config.js), Browser und Backend können deshalb nie in
// verschiedenen Stripe-Modi landen. Publishable Keys sind öffentlich — der
// Endpoint braucht keine Authentifizierung.
let stripePromise;

const fetchPublishableKey = async () => {
  const response = await fetch('/api/v1/config/stripe');
  if (!response.ok) {
    throw new Error(`Stripe-Konfiguration nicht abrufbar (${response.status})`);
  }
  const { publishableKey } = await response.json();
  if (!publishableKey) {
    throw new Error('Stripe-Konfiguration ohne publishableKey');
  }
  return publishableKey;
};

// Stripe.js wird erst beim Bezahlschritt geladen (nicht auf jeder Seite) und das
// Ergebnis memoisiert, damit es prozessweit nur einmal initialisiert wird —
// unabhängig davon, ob der Bezahlschritt aus dem Warenkorb oder aus dem
// Firmen-Abo kommt. Schlägt der Abruf fehl, wird die Memoisierung verworfen,
// damit der nächste Bezahlversuch es erneut probiert.
const getStripePromise = () =>
  (stripePromise ??= fetchPublishableKey()
    .then(loadStripeWithRetry)
    .catch((error) => {
      stripePromise = undefined;
      throw error;
    }));

export default getStripePromise;
